// // import { FaBars, FaBell } from "react-icons/fa";
// // import { useEffect, useState } from "react";
// // import API from "../../services/api";
// // import "../../styles/sidebar.css";
// // import { useLocation } from "react-router-dom";

// // function Navbar({ collapsed, setCollapsed }) {
// //   const location = useLocation();

// // const getPageTitle = () => {
// //   const path = location.pathname;

// //   if (path.includes("dashboard")) return "Dashboard";
// //   if (path.includes("leads")) return "Leads";
// //   if (path.includes("calllogs")) return "Call Logs";
// //   if (path.includes("followups")) return "Followups";
// //   if (path.includes("meetings")) return "Meetings";
// //   if (path.includes("support")) return "Support";
 
// //   if (path.includes("dailysummary")) return "Daily Summary";
// //   if (path.includes("notifications")) return "Notifications";
// //   if (path.includes("packages")) return "Packages";
// //   if (path.includes("services")) return "Services";
// //   if (path.includes("users")) return "Users";
// //   if (path.includes("settings")) return "Settings";

// //   return "Dashboard";
// // };



// //   const [profilePic, setProfilePic] = useState("");
// //   const [notifications, setNotifications] = useState([]);

// //   const name = localStorage.getItem("name");
// //   const role = localStorage.getItem("role");

// //   useEffect(() => {
// //     const fetchProfile = async () => {
// //       try {
// //         const res = await API.get("/users/profile");
// //         console.log(res.data); // 👈 debug
// //         setProfilePic(res.data.profile_pic);
// //       } catch (err) {
// //         console.log(err);
// //       }
// //     };

// //     fetchProfile();
// //   }, []);

// //   return (
// //     <div className="navbar">

// //       {/* LEFT */}
// //       <div className="nav-left">
// //         <FaBars onClick={() => setCollapsed(!collapsed)} />
// //         <h3>{getPageTitle()}</h3>
// //       </div>







// //       {/* RIGHT */}
// //       <div className="nav-right">

// //         {/* 🔔 BELL */}
// //         <div className="bell-container">
// //           <FaBell className="bell-icon" />
// //           {notifications.length > 0 && (
// //             <span className="bell-badge">
// //               {notifications.length}
// //             </span>
// //           )}
// //         </div>

// //         {/* PROFILE */}
// //         <div className="profile-box">
// //           <img
// //             src={
// //               profilePic
// //                 ? `http://localhost:5000/uploads/${profilePic}`
// //                 : "https://via.placeholder.com/40"
// //             }
// //             alt="profile"
// //           />
// //           <span>{name}</span>
// //         </div>

// //       </div>
// //     </div>
// //   );
// // }

// // export default Navbar;

// import { FaBars, FaBell } from "react-icons/fa";
// import { useEffect, useState } from "react";
// import API from "../../services/api";
// import "../../styles/sidebar.css";
// import { useLocation, useNavigate } from "react-router-dom";

// function Navbar({ collapsed, setCollapsed }) {

//   const location = useLocation();
//   const navigate = useNavigate();

//   const [profilePic, setProfilePic] = useState("");
//   const [count, setCount] = useState(0);

//   const name = localStorage.getItem("name");
//   const userId = localStorage.getItem("userId");

//   // ✅ PAGE TITLE
//   const getPageTitle = () => {
//     const path = location.pathname;

//     if (path.includes("dashboard")) return "Dashboard";
//     if (path.includes("leads")) return "Leads";
//     if (path.includes("calllogs")) return "Call Logs";
//     if (path.includes("followups")) return "Followups";
//     if (path.includes("meetings")) return "Meetings";
//     if (path.includes("support")) return "Support";
//     if (path.includes("notifications")) return "Notifications";

//     return "Dashboard";
//   };

//   // ✅ FETCH PROFILE
//   useEffect(() => {
//     API.get("/users/profile")
//       .then(res => setProfilePic(res.data.profile_pic))
//       .catch(err => console.log(err));
//   }, []);

//   // ✅ FETCH UNREAD COUNT
//   const fetchCount = () => {
//     if (!userId) return;

//     API.get(`/notifications/unread/${userId}`)
//       .then(res => setCount(res.data.count))
//       .catch(err => console.log(err));
//   };

//   useEffect(() => {
//     fetchCount();

//     // 🔄 auto refresh every 5 sec
//     const interval = setInterval(fetchCount, 5000);
//     return () => clearInterval(interval);

//   }, [userId]);

//   return (
//     <div className="navbar">

//       {/* LEFT */}
//       <div className="nav-left">
//         <FaBars onClick={() => setCollapsed(!collapsed)} />
//         <h3>{getPageTitle()}</h3>
//       </div>

//       {/* RIGHT */}
//       <div className="nav-right">

//         {/* 🔔 BELL */}
//         <div
//           className="bell-container"
//           onClick={() => navigate("/notifications")}
//         >
//           <FaBell className="bell-icon" />

//           {count > 0 && (
//             <span className="bell-badge">{count}</span>
//           )}
//         </div>

//         {/* PROFILE */}
//         <div className="profile-box">
//           <img
//             src={
//               profilePic
//                 ? `http://localhost:5000/uploads/${profilePic}`
//                 : "https://via.placeholder.com/40"
//             }
//             alt="profile"
//           />
//           <span>{name}</span>
//         </div>

//       </div>
//     </div>
//   );
// }

// export default Navbar;


import { FaBars } from "react-icons/fa";
import { useEffect, useState } from "react";
import API from "../../services/api";
import "../../styles/navbar.css";
import { useLocation, useNavigate } from "react-router-dom";
import NotificationCenter from "../notifications/NotificationCenter";

function Navbar({ collapsed, setCollapsed }) {

  const location = useLocation();
  const navigate = useNavigate();

  const [count, setCount] = useState(0);

  const name = localStorage.getItem("name");
  const userId = localStorage.getItem("userId");

  // ✅ LOGOUT FUNCTION
  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  // ✅ PAGE TITLE
  const getPageTitle = () => {
    const path = location.pathname;

    if (path.includes("dashboard")) return "Dashboard";
    if (path.includes("leads")) return "Leads";
    if (path.includes("calllogs")) return "Call Logs";
    if (path.includes("followups")) return "Followups";
    if (path.includes("meetings")) return "Meetings";
    if (path.includes("support")) return "Support";
    if (path.includes("notifications")) return "Notifications";
    // if (path.includes("dailysummary")) return "Daily Summary";
    if (path.includes("settings")) return "Settings";
    if (path.includes("packages")) return "Packages";
    return "Dashboard";
  };

  // ✅ FETCH UNREAD COUNT
 const fetchCount = () => {
  if (!userId) return;

  API.get(`/notifications/unread/${userId}`)
    .then(res => setCount(res.data.count))
    .catch(err => console.log(err));
};

useEffect(() => {
  fetchCount();
}, [location.pathname]);

  return (
    <div className="navbar">

      {/* LEFT */}
      <div className="nav-left">
        <FaBars onClick={() => setCollapsed(!collapsed)} />
        <h3>{getPageTitle()}</h3>
      </div>

      {/* RIGHT */}
      <div className="nav-right">

        {/* 🔔 NOTIFICATION CENTER (replaces the old basic bell dropdown) */}
        <NotificationCenter />

        {/* 👤 NAME + LOGOUT */}
        <div className="profile-box">
          <span className="user-name">{name}</span>

          <button className="logout-btn" onClick={handleLogout}>
            Logout
          </button>
        </div>

      </div>
    </div>
  );
}

export default Navbar;